<form [formGroup]="passwordForm" autocomplete="off" (ngSubmit)="onSubmit()">
  <div class="form-group" [ngClass]="{'is-form-error': getForm.newPassword.errors }">
    <label for="new-password"><strong>{{ 'pages.change-password.form.new-password' | translate }}</strong></label>
    <div class="input-group input-group-flex">
      <div class="input-content">
        <input id="new-password" formControlName="newPassword" [type]="checkType()" class="form-item" value="" aria-required="true" aria-invalid="false" autocomplete="off" (blur)="newPasswordValidator()" tabindex="0" aria-describedBy="newPassword-desc">
        @if (getForm.newPassword.errors) {
          <span id="new-password-alert" aria-hidden="true" class="icon icon--alert"></span>
        }
      </div>
      <div class="input-group-append">
        <span class="material-icons-outlined md-36" id="new-password-eye" [attr.aria-label]="ariaLabelShowPassword()" matSuffix (click)="toggleShowPassword()" (keypress)="toggleShowPassword()" role="button" tabindex="0">
          {{hide ? 'visibility' : 'visibility_off'}}
        </span>
      </div>
    </div>
    @if (getForm.newPassword.errors) {
      <p class="is-form-error" [innerHTML]="getFormValidationErrors(getForm.newPassword.errors)"></p>
    }
  </div>
  <div class="form-group" [ngClass]="{'is-form-error': getForm.confirmPassword.errors }">
    <label for="confirm-new-password"><strong>{{ 'pages.change-password.form.confirm-password' | translate }}</strong></label>
    <div class="input-group input-group-flex">
      <div class="input-content">
        <input id="confirm-new-password" formControlName="confirmPassword" [type]="checkTypeConfirm()" class="form-item" aria-required="true" aria-invalid="false" autocomplete="off" tabindex="0" aria-describedBy="confirm-new-password-desc">
        @if (getForm.confirmPassword.errors) {
          <span id="confirm-new-password-alert" aria-hidden="true" class="icon icon--alert"></span>
        }
      </div>
      <div class="input-group-append">
        <span class="material-icons-outlined md-36" id="confirm-new-password-eye" [attr.aria-label]="ariaLabelShowPasswordConfirm()" matSuffix (click)="toggleShowPasswordConfirm()" (keypress)="toggleShowPasswordConfirm()" role="button" tabindex="0">
          {{hideConfirm ? 'visibility' : 'visibility_off'}}
        </span>
      </div>
    </div>
    @if (getForm.confirmPassword.errors) {
      <p class="is-form-error" id="confirm-new-password-desc">{{ getFormValidationErrors(getForm.confirmPassword.errors) }}</p>
    }
  </div>

  @if (!loading) {
    <div>
      <button type="submit" [disabled]="!formValid()" class="btn btn--primary mr-1" tabindex="0">{{ 'buttons.update' | translate }}</button>
      <a attr.href="{{ 'links.uoc.url' | translate }}" class="text-small" tabindex="0">{{ 'links.uoc.name' | translate }}</a>
    </div>
  }
  <div class="spinner-wrapper">
    @if (loading) {
      <img src="assets/img/spinner.gif" class="loading" alt="{{ 'app.loading' | translate }}">
    }
  </div>

</form>
